import React, { useContext, useEffect, useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { liteUserNewAddressUrl } from "Utils/constant";
import { getAuthToken } from "Utils/common";
import { AppContext } from "Store";
import axios from "axios";
import { getSTDefaultContact } from "Utils/addressUtils";
const NewAddressForm = (props: any) => {
  const { open, onSuccess, onFailed, setNewAddressModal } = props;
  const { loginState, refetchCustomerDetails } = useContext(AppContext);
  const defaultContact = getSTDefaultContact(loginState);
  const [loading, setLoading] = useState(false);

  const [initialValues] = useState({
    nickName: defaultContact.name,
    phone: defaultContact.phone,
    region: "",
    address: "",
    invoice: "",
  });
  const [form] = Form.useForm();
  const saveHandler = (values: any) => {
    if (loading) return;
    const userInfo = loginState?.user?.user;

    let currentAttentionTo = values.nickName + "," + values.phone;
    let addressObj = {
      attentionTo: currentAttentionTo,
      building: "",
      city: values.region,
      companyOrInstitution: values.invoice,
      departmentOrLab: "",
      nickName: values.nickName,
      phoneNumber: values.phone,
      state: "",
      street: values.address,
      zipCode: "",
    };
    let submitShippingAddress = addressObj;
    let submitBillToAddress = {
      ...addressObj,
      isSameAsShippingAddress: true,
    };
    let requestBody = {
      billingAddress: submitBillToAddress,
      shippingAddress: submitShippingAddress,
    };
    console.log("new address requestBody", requestBody);
    setLoading(true);
    axios(liteUserNewAddressUrl, {
      method: "POST",
      headers: {
        userid: userInfo.userId,
        username: userInfo.userName,
        Authorization: getAuthToken(),
        "Content-Type": "application/json",
      },
      data: requestBody,
    })
      .then(async (resp) => {
        console.log("resp", resp);
        if (resp.status === 200) {
          const respData = resp.data;
          console.log("respData", respData);
          const refetchResp = await refetchCustomerDetails();
          console.log("refetchResp", refetchResp);
          setNewAddressModal(false);
          setLoading(false);
          onSuccess?.(resp);
        } else {
          if (resp.data.status === "address_already_registered") {
            window.location.reload();
            return;
          }
          message.error("保存失败，请重试");
          setLoading(false);
          onFailed?.(resp);
        }
      })
      .catch((err) => {
        message.error("保存失败，请重试");
        setLoading(false);
        onFailed?.(err);
      });
  };

  useEffect(() => {
    if (loginState.status === "login") {
      const defaultContact = getSTDefaultContact(loginState);
      form.setFieldsValue({
        nickName: defaultContact.name,
        phone: defaultContact.phone,
      });
    }
  }, [loginState.status])

  return (
    <Modal
      open={open}
      onCancel={() => {
        setNewAddressModal(false);
      }}
      okButtonProps={{ loading: loading }}
      onOk={() => form.submit()}
      title="收货方信息"
      rootClassName="add-shipping-address-modal-root mobilePage"
      className="add-shipping-address-modal mobilePage"
      okText="保存"
      cancelText="取消"
    >
      <div className="shipping-detail-info">请完善地址信息</div>
      <Form
        form={form}
        initialValues={initialValues}
        layout="vertical"
        onFinish={saveHandler}
      >
        <Form.Item
          name="nickName"
          label="收货人"
          rules={[{validator: (rule, value) => {
            if (!value) {
              return Promise.reject("请输入收货人");
            }
            if (value.length > 30) {
              return Promise.reject("收货人姓名最多可输入30个字符");
            }
            return Promise.resolve();
          }}]}
        >
          <Input
          maxLength={30}
          placeholder="填写收货人" />
        </Form.Item>
        <Form.Item
          name="phone"
          label="手机号"
          rules={[{ validator: (rule, value) => {
            if (!value) {
              return Promise.reject("请输入手机号");
            }
            const reg = /^((?:\+?86\s*)?\d{11}|\d{11}|\d{3}-\d{8}|\d{4}-\d{7})$/;
            if (!reg.test(value)) {
              return Promise.reject("手机号格式不正确");
            }
            return Promise.resolve();
          }}]}
        >
          <Input placeholder="填写手机号" />
        </Form.Item>
        <Form.Item
          name="region"
          label="所在地区"
          rules={[{ validator: (rule, value) => {
            if (!value) {
              return Promise.reject("请输入所在地区");
            }
            if (value.length > 60) {
              return Promise.reject("所在地区最多可输入60个字符");
            }
            return Promise.resolve();
          }}]}
        >
          <Input
          maxLength={60}
          placeholder="XX省XX市XX区" />
        </Form.Item>
        <Form.Item
          name="address"
          label="详细地址"
          rules={[{ validator: (rule, value) => {
            if (!value) {
              return Promise.reject("请输入详细地址");
            }
            if (value.length > 120) {
              return Promise.reject("详细地址最多可输入120个字符");
            }
            return Promise.resolve();
          }}]}
        >
          <Input
          maxLength={120}
          placeholder="填写详细地址, 例: 明月路1257号1号楼101" />
        </Form.Item>
        <Form.Item
          name="invoice"
          label="发票抬头"
          rules={[{ validator: (rule, value) => {
            if (!value) {
              return Promise.reject("请输入发票抬头");
            }
            if (value.length > 150) {
              return Promise.reject("发票抬头最多可输入150个字符");
            }
            return Promise.resolve();
          }}]}
        >
          <Input maxLength={150} placeholder="请输入发票抬头"/>
        </Form.Item>
      </Form>
      <div className="add-address-note">
          请留意：具体开票信息在您提交订单后会有客服人员联系确认，请保持电话畅通。
      </div>
    </Modal>
  );
};

export default NewAddressForm;
